import { render } from "./ClientsInsightComponent.vue?vue&type=template&id=b84a23dc&scoped=true"
import script from "./ClientsInsightComponent.vue?vue&type=script&lang=js"
export * from "./ClientsInsightComponent.vue?vue&type=script&lang=js"

import "./ClientsInsightComponent.vue?vue&type=style&index=0&id=b84a23dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84a23dc"]])

export default __exports__